import React, {FC, useContext, useState} from "react";
import BlankPage from "../../../../Components/Layout/BlankPage";
import {useOutletContext} from "react-router-dom";
import Catalog from "../../../../Entity/Catalog";
import ListingSetting from "Components/Form/ListingSetting";
import ListingSettingEntity from 'Entity/Collection/ListingSetting';
import FormEmpty from "../../../../Vendor/Components/FormEmpty";
import LoadingButton from "../../../../Components/Button/LoadingButton";
import {BannerContext} from "../../../../Vendor/Context/BannerContextProvider";
import {useTranslation} from "react-i18next";
import DataCollection from "../../../../Entity/DataCollection";
import {UserContext} from "../../../../Vendor/Context/UserContextProvider";
import User from "../../../../Entity/User";

const ListingPage: FC = () => {
    const { currentUser, setCurrentUser } = useContext(UserContext);
    const [catalog, setCatalog] = useOutletContext<[Catalog, (catalog: Catalog) => void]>()
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [success, setSuccess] = useState<boolean>(false)
    const { setBanner } = useContext(BannerContext);

    const setListing = (listing: ListingSettingEntity) => {
        let tempCatalog = {...catalog}
        tempCatalog.listingSetting = listing

        setCatalog(tempCatalog)
    }

    const onSubmit = () => {
        setIsLoading(true)
    }
    const onResponse = () => {
        setIsLoading(false)
    }
    const onSuccess = (data: User) => {
        setCurrentUser(data)
        setBanner({type: 'success', i18nTitle: 'app.save', i18nMessage: 'app.data_saved_message'})
    }
    const onError = () => {
        setSuccess(false)
    }

    return <BlankPage>
        <FormEmpty
            path={"/admin/edition/collection/listing-setting/catalog/" + catalog.id}
            formPath={!!catalog.id}
            children={<div className="row justify-content-end align-items-center">
                <div className="col-auto">
                    <LoadingButton type="submit" isLoading={isLoading}>
                        {t( 'app.validate' )}
                    </LoadingButton>
                </div>
            </div>}
            method={catalog.id ? 'PATCH' : 'POST'}
            onSubmit={onSubmit}
            onResponse={onResponse}
            onSuccess={onSuccess}
            onError={onError}
        />
    </BlankPage>
}

export default ListingPage